import React from "react";
import { Link } from "react-router-dom";
import { GET_USER_LEVEL } from "../../../helpers";

import { EmptyData } from "../../Global/EmptyData/EmptyData";

import "./Notifications.css";

export const Notifications = ({innerRef, newNotifications, notificationsList, seenNotif, submitSeenNotifications, setShowNotifications, setSeenNotif, markAllAsRead}) => {
  // const generateLink = (type) => {
  //   switch (type) {
  //     case 'import': return '/dashboard/adminfileimport'
  //     case 'upload': return '/dashboard/adminfileimport'
      
  //     default: return'/';
  //   }
  // }

  // handleSelectAnotherProject

  const generateLink = (type) => {
    if ( type === 'upload' || type === 'import' || type === 'report') return '/dashboard/adminfileimport'
    else if (type === 'threshold') return '/dashboard/tresholds'
    else if (type === 'returns_redirect ') {
      return parseInt(GET_USER_LEVEL(), 10) < 4 ? '/dashboard/returnsusertable' : '/dashboard/returnsadmintable'
    }
  }

  const listNotifications = () => {
    return notificationsList.map((item, index) => {
      let foundInSeen = seenNotif.findIndex((seenItem) => item.id === seenItem.id) > -1 ? true : false

      return (
        <div className={`Notifications_item ${(item.status === 'seen' || foundInSeen) ? 'seen' : ''} type-${item.type}`} key={item.id +'_notif'}>
          <Link
            to={generateLink(item.type)}
            exact="true" 
            onClick={() => {

              if (item.type === 'upload') sessionStorage.setItem("selectedTab", 0);
              else if (item.type === 'import') sessionStorage.setItem("selectedTab", 3);
              else if (item.type === 'report') sessionStorage.setItem("selectedTab", 4);

              submitSeenNotifications(item.id, 'change')
              setShowNotifications(false)
            }}
          >
            {/* <div className={`Notifications_item__icon ${item.state ?? 'blank'}`} /> */}
            {item?.country?.img
              ? <img src={item.country.img} className="flag-icon-img" alt={item.country.name}/>
              : item?.state && <div className={`Notifications_item__icon ${item.state ?? 'blank'}`} />}


            <div className="Notifications_item__name">
              <div className="title">{item.name}</div>
              <div className="date">{item.created_at}</div>
            </div>
          </Link>

          <input type="checkbox"
            checked={foundInSeen}
            disabled={item.status === 'seen'}
            onChange={(e) => {
              submitSeenNotifications(item.id)
              !foundInSeen && setSeenNotif([...seenNotif, {id: item.id}])
            }}/>
        </div>
      )
    }
      


    )
  }

  return (
    <div className="Notifications">
      {notificationsList.length > 0 && (
        <div className="Notifications__top">
          <button 
            className={`widget__title-wrapper__link flex ${newNotifications <= 0 && ' all-read'}`}
            disabled={notificationsList.length <= 0}
            onClick={markAllAsRead}
          >
            <div className="icon success--violet"></div>
            Mark all as read
          </button>
        </div>
      )}



      {notificationsList.length > 0 
        ? listNotifications()
        : <EmptyData title={'You don’t have any notifications yet'} type="messages"/>
      }
    </div>
  )
}